(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fs-carousel"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-fs-car]').forEach(function(s){var t=s.querySelector('[data-fs-track]');s.querySelectorAll('.fs-car__btn').forEach(function(b){b.addEventListener('click',function(){var it=t.querySelector('.fs-car__item');var w=it?it.getBoundingClientRect().width+24:300;t.scrollBy({left:w*parseInt(b.dataset.dir,10)*2,behavior:'smooth'})})})});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
